"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.planGroupManagementSchema = exports.planPermissionsSchema = void 0;
const zod_1 = require("zod");
const permission_profile_1 = require("../../../permission_profile");
exports.planPermissionsSchema = zod_1.z.array(zod_1.z.object({
    group_id: zod_1.z.number(),
    sources: zod_1.z.array(zod_1.z.nativeEnum(permission_profile_1.PlanGroupPermission)),
    calc: zod_1.z.array(zod_1.z.nativeEnum(permission_profile_1.PlanGroupPermission)),
    can_unlock_periods: zod_1.z.boolean(),
    release_periods_view: zod_1.z.boolean().optional(),
    can_edit_statement_panel: zod_1.z.boolean().optional(),
}));
exports.planGroupManagementSchema = zod_1.z.object({
    plan_permissions: exports.planPermissionsSchema,
});
